import LegalDocument from "pages/components/LegalDocument";
import { useTranslation } from "react-i18next";
import { TERMS_LAST_UPDATED, TERMS_VERSION, termsSections } from "./content";

/** Terms & Conditions. The text lives in content.tsx; this is layout only. */
const Terms: React.FC = () => {
  const { t } = useTranslation("legal");

  return (
    <LegalDocument
      title={t("common.terms_title")}
      version={TERMS_VERSION}
      lastUpdated={TERMS_LAST_UPDATED}
      intro={t("common.terms_intro")}
      sections={termsSections(t)}
    />
  );
};

export default Terms;
